export default "__VITE_ASSET__D_q_8zxH__"